export default "/packs/images/default_423x635~e399fa23c6534671bd374c671fe48df4.png";